import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=728022a2&scoped=true"
import script from "./tab.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./tab.vue?vue&type=style&index=0&id=728022a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728022a2",
  null
  
)

export default component.exports